import { Checkbox, FormControl, InputLabel, ListItemText } from '@mui/material';

import { useTrans } from "~/hooks/useTrans";
import { MyMenuItem, MySelect } from "~/mui/MySelect";
import { TProjectBillingMethod } from "~/providers/interfaces";

import "./style.less";

interface IBillingMethodSelect {
	value: string | null;
	onChange: (value: string | null) => void;
}

export default function BillingMethodSelect({
	value,
	onChange = () => {},
}: IBillingMethodSelect) {
	const { trans, paymentMethodToShortcut } = useTrans();

	function getValue() {
		if (typeof value === "string") {
			return value.split(",");
		}

		return [];
	}

	function isChecked(businessPlan: TProjectBillingMethod) {
		const values = value || "";

		return values.indexOf(businessPlan) !== -1;
	}

	function getTitle(selected: Array<string>) {
		if (selected.length > 0) {
			return selected.map((item: TProjectBillingMethod) => paymentMethodToShortcut(item)).join(", ");
		}

		return trans("allProjectsPage.filter.billingMethod.empty");
	}

	function updateFilter(newValue: Array<string>) {
		let updatedValue = null;

		if (newValue.length !== 0) {
			updatedValue = newValue.join(",");
		}

		onChange(updatedValue);
	}

	return <FormControl size="small" sx={{ minWidth: "175px" }}>
		<InputLabel shrink={true}>
			{ trans("createProject.billingMethod") }
		</InputLabel>
		<MySelect
			value={getValue()}
			onChange={event => updateFilter(event.target.value as Array<string>)}
			label={trans("createProject.billingMethod")}
			renderValue={(selected: Array<string>) => getTitle(selected)}
			multiple={true}
			className="billingMethodSelect"
		>
			<MyMenuItem value="none">
				<Checkbox checked={isChecked("none")} />
				<ListItemText primary={ trans("createProject.billingMethod.none") } />
			</MyMenuItem>
			<MyMenuItem value="wallet">
				<Checkbox checked={isChecked("wallet")} />
				<ListItemText primary={ trans("createProject.billingMethod.wallet") } />
			</MyMenuItem>
			<MyMenuItem value="sos">
				<Checkbox checked={isChecked("sos")} />
				<ListItemText primary={ trans("createProject.billingMethod.sos") } />
			</MyMenuItem>
			<MyMenuItem value="barter">
				<Checkbox checked={isChecked("barter")} />
				<ListItemText primary={ trans("createProject.billingMethod.barter") } />
			</MyMenuItem>
		</MySelect>
	</FormControl>;
}
